import { Input, Translation } from '@ps/web-shared-components';
import {
  maxLength,
  minLength,
  mustContainOnlyLatinCharacters,
  mustNotContainSymbols,
  required
} from '@ps/web-shared-validators';
import React from 'react';

import { RESTRICTED_SYMBOLS } from '../OccupationDetails/OccupationDetails';

import {
  TXTWCL_Full_name_of_the_PEP_HIO,
  TXTWCL_PEP_HIO_Details,
  TXTWCL_Source_of_funds_being_deposite_ELL,
  TXTWCL_Source_of_wealth_used_for_fund_ELL,
  TXTWCL_This_information_is_kept_confi_ELL_1,
  TXTWCL_Your_relationship
} from './PEPHIODetails.messages.json';

const PEPHIODetails: React.FC = () => (
  <>
    <br />
    <Translation tagName="b" {...TXTWCL_PEP_HIO_Details} />
    <br />
    <Translation {...TXTWCL_This_information_is_kept_confi_ELL_1} />
    <Input
      id="pepHioName"
      label={TXTWCL_Full_name_of_the_PEP_HIO}
      validators={[
        required(),
        maxLength(49),
        mustNotContainSymbols(RESTRICTED_SYMBOLS),
        mustContainOnlyLatinCharacters()
      ]}
    />
    <Input
      id="relationshipToPepHio"
      label={TXTWCL_Your_relationship}
      validators={[
        required(),
        minLength(2),
        maxLength(49),
        mustNotContainSymbols(RESTRICTED_SYMBOLS),
        mustContainOnlyLatinCharacters()
      ]}
    />
    <Input
      id="sourceOfFunds"
      label={TXTWCL_Source_of_funds_being_deposite_ELL}
      validators={[
        required(),
        minLength(2),
        maxLength(49),
        mustNotContainSymbols(RESTRICTED_SYMBOLS),
        mustContainOnlyLatinCharacters()
      ]}
    />
    <Input
      id="sourceOfWealth"
      label={TXTWCL_Source_of_wealth_used_for_fund_ELL}
      validators={[
        required(),
        minLength(2),
        maxLength(49),
        mustNotContainSymbols(RESTRICTED_SYMBOLS),
        mustContainOnlyLatinCharacters()
      ]}
    />
  </>
);

export default PEPHIODetails;
